import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomExpansionPanelComponent } from './custom-expansion-panel.component';



@NgModule({
  declarations: [
    CustomExpansionPanelComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CustomExpansionPanelComponent,
  ]
})
export class CustomExpansionPanelModule { }
